import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type IncidentReportIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

/** Folded-corner sheet with an exclamation mark — incidents. */
export const IncidentReportIcon = ({
  size = 16,
  color,
  colorScheme = 'dark',
  className,
}: IncidentReportIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  // Decorative: unlike most icons here (aria-label + role='img'), this one
  // is aria-hidden. It always sits beside text that carries the meaning (a
  // StatTile label, a feed row title), so a label would only repeat or
  // contradict it, and a hardcoded English one wouldn't be translated.
  return (
    <svg
      aria-hidden='true'
      className={className}
      fill='none'
      height={size}
      // The 14.4 glyph sits at a 5% inset inside the 16px icon frame.
      viewBox='-0.8 -0.8 16 16'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 0.75H8.50586C8.5538 0.75 8.60128 0.764116 8.6416 0.790039L13.5352 3.93555C13.6066 3.98147 13.6502 4.06061 13.6504 4.14551V13.4004C13.6502 13.5382 13.5382 13.6502 13.4004 13.6504H1C0.862057 13.6504 0.750207 13.5383 0.75 13.4004V1C0.750003 0.861931 0.861931 0.75 1 0.75Z'
        stroke={resolvedColor}
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M7.2 3.2V7.6'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeWidth={1.5}
      />
      <path
        d='M7.2 10.4L7.2 11.2'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
